import { UlmClientType } from "@custom-types/ulm-types";
import { UrlUtils } from "@stellar/utils";
import { isEmbedded, requestParentToRedirect } from "@utils/browser-utils";

interface RedirectClientProps {
  /** ULM client */
  client: UlmClientType;

  /** redirect URL */
  redirectUrl: string;
}

/**
 * Performs a redirect to the passed URL
 * For some clients the redirect will be carried out in the parent window
 *
 * @param client ULM client. Ex: sphereDashboard, streamOrbis
 * @param redirectUrl URL string to redirect to
 * @throws {Error} if the passed URL string is not a valid URL
 */
export function redirectClient({
  client,
  redirectUrl,
}: RedirectClientProps): void {
  const redirectUrlObject = UrlUtils.constructUrl({ url: redirectUrl });

  // Throw error if there is no valid URL
  if (!redirectUrlObject) {
    throw new Error("Invalid redirect URL");
  }

  // For clients that embed the ULM in an iFrame we send a window message to the
  // parent window so the parent window handles the redirect themselves, avoiding
  // potential redirect security issues in browsers.
  // For any other client we simply redirect from the ULM.
  if (isEmbedded(client)) {
    requestParentToRedirect(redirectUrlObject);
  } else {
    UrlUtils.redirectToUrl(redirectUrlObject.href);
  }
}
